import React, { useEffect, useState } from "react";
import { Header } from "../../../components/SpearParts/Layouts/Header";
import { SeachSection } from "../../../components/Engineering/Layout/SeachSection";
import NoData from "../../../components/NoData/Index";
import { useLocation, useNavigate, Link } from "react-router-dom";
import EngMiddle from "../../../components/Engineering/Layout/EngMiddle";
import TopNavBar from "../../../components/SpearParts/Layouts/TopNavBar";
import TopSearchBar from "../../../components/SpearParts/Layouts/TopSearchBar";

const EngineeringSubcategory = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { category, subcategories, selectedFilters } = location.state || {};

  useEffect(() => {
    if (!category) navigate("/engineering/category");
  }, []);

  const SubcategoryCard = ({ subcat }) => {
    return (
      <div
        className="category-item"
        style={{ cursor: "pointer" }}
        onClick={() =>
          navigate(
            `/engineering/productlist?categoryId=${category._id}&subcategoryId=${subcat._id}`,
            {
              state: {
                selectedFilters: {
                  ...selectedFilters,
                  categoryId: category._id,
                  subcategoryId: subcat._id,
                },
              },
            }
          )
        }
      >
        <div className="d-flex flex-column align-items-center">
          {subcat?.image && <img src={subcat.image} alt={subcat.name} />}
          <h6>{subcat.name}</h6>
        </div>
      </div>
    );
  };
  const sectionStyle = {
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundImage: "url(/images/bnr-bg.png)",
  };
  const beforeImageStyle = {
    content: '""',
    position: "absolute",
    left: 0,
    top: 0,
    width: "360px",
    height: "100%",
    backgroundImage: "url(/images/eng-head-image.png)",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "left top",
    backgroundSize: "contain",
    pointerEvents: "none",
    zIndex: 1,
  };

  return (
    <>
      <div className="New-Eng-Dashboard" style={sectionStyle}>
        {/* <Header /> */}
       <div className="before-image" style={beforeImageStyle}></div>
          <div className="Main-div">
            <TopNavBar />
            <div className="TopSearchBar">
              <TopSearchBar />
            </div>
            <div className="container">
              {/* <button
            className="back btn btn-light"
            onClick={() => navigate(-1)}
            style={{
              border: "none",
              backgroundColor: "#dbe4f0ff",
              padding: "8px 14px",
              borderRadius: "6px",
            }}
          >
            <i className="fa fa-long-arrow-left"></i> Back
          </button> */}

              <EngMiddle initialFilters={selectedFilters} />

              <h4 className="mt-4">Select Subcategory</h4>

              <div className="category-grid">
                {subcategories && subcategories.length > 0 ? (
                  subcategories.map((item) => (
                    <SubcategoryCard key={item._id} subcat={item} />
                  ))
                ) : (
                  <div className="text-center">
                    <NoData />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
    </>
  );
};

export default EngineeringSubcategory;
